import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "select", "results"]

  connect() {
    this.selectTarget.classList.add("d-none")

    const selected = this.selectTarget.selectedOptions[0]
    this.inputTarget.value = selected.value === "" ? "" : selected.textContent

    this.outsideClickHandler = (event) => {
      if (!this.element.contains(event.target)) this.#hide()
    }
    document.addEventListener("mousedown", this.outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("mousedown", this.outsideClickHandler)
  }

  open() {
    this.#render("")
    this.inputTarget.select()
  }

  filter() {
    this.#render(this.inputTarget.value)
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.#hide()
  }

  choose(event) {
    const item = event.target.closest("[data-value]")
    if (!item) return

    const value = item.dataset.value
    this.selectTarget.value = value
    this.inputTarget.value = value === "" ? "" : item.textContent
    this.#hide()
  }

  #render(query) {
    const keyword = query.trim().toLowerCase()
    const fragment = document.createDocumentFragment()

    const clearOption = this.selectTarget.options[0]
    fragment.appendChild(this.#buildItem(clearOption.value, clearOption.textContent, true))

    const matches = Array.from(this.selectTarget.querySelectorAll("optgroup option")).filter(
      (option) => option.textContent.toLowerCase().includes(keyword),
    )
    matches.forEach((option) => {
      fragment.appendChild(this.#buildItem(option.value, option.textContent, false))
    })

    if (matches.length === 0) {
      const empty = document.createElement("div")
      empty.className = "dropdown-item-text text-muted small"
      empty.textContent = "該当なし"
      fragment.appendChild(empty)
    }

    this.resultsTarget.replaceChildren(fragment)
    this.#show()
  }

  #buildItem(value, label, isClear) {
    const button = document.createElement("button")
    button.type = "button"
    button.className = isClear ? "dropdown-item text-muted" : "dropdown-item text-truncate"
    button.dataset.value = value
    button.textContent = label
    return button
  }

  #show() {
    this.resultsTarget.classList.add("show")
  }

  #hide() {
    this.resultsTarget.classList.remove("show")
  }
}
